// extracted by mini-css-extract-plugin
export default {"strong":"strong__FirstVisitNotification__FQQUO"};